<template>
    <div class="commission-content">
        <h5 class="font-bold pt-6">Choose Employee - Owner Commission</h5>

        <p class="text-lg pt-4 pb-2">For Service</p>
        <div class="my-radio-list flex">
            <div v-for="(item, index) in serviceCommission" :key="index">
                <!-- <input class="checkbox-tools" type="radio" name="commission-service" :id="`commission-service-${item.id}`" :checked="service_selected.id == item.id"
                    @click="selectItem(item)" />
                <label class="for-checkbox-tools text-lg" :for="`commission-service-${item.id}`">
                    <span v-if="item.name != 'other'">{{item.start}} - {{item.end}}</span>
                    <span v-else>Other</span>
                </label> -->
                <vs-button type="border" class="text-lg percentage-btn" :class="{'active': service_selected.id == item.id}" @click="selectItem(item)">
                    <span v-if="item.name != 'other'">{{item.start}} - {{item.end}}</span>
                    <span v-else-if="item.end == -1">Other</span>
                    <span v-else>{{item.start}} - {{item.end}}</span>
                </vs-button>
            </div>
        </div>

        <p class="text-lg pt-6 pb-2">For Product</p>
        <div class="my-radio-list flex">
            <div v-for="(item, index) in productCommission" :key="index">
                <!-- <input class="checkbox-tools" type="radio" name="commission-product" :id="`commission-product-${item.id}`" :checked="product_selected.id == item.id"
                    @click="selectItem(item)" />
                <label class="for-checkbox-tools text-lg" :for="`commission-product-${item.id}`">
                    <span v-if="item.name != 'other'">{{item.start}} - {{item.end}}</span>
                    <span v-else>Other</span>
                </label> -->
                <vs-button type="border" class="text-lg percentage-btn" :class="{'active': product_selected.id == item.id}" @click="selectItem(item)">
                    <span v-if="item.name != 'other'">{{item.start}} - {{item.end}}</span>
                    <span v-else-if="item.end == -1">Other</span>
                    <span v-else>{{item.start}} - {{item.end}}</span>
                </vs-button>
            </div>
        </div>

        <p class="text-lg pt-6 pb-2">For Giftcard</p>
        <div class="my-radio-list flex">
            <div v-for="(item, index) in giftcardCommission" :key="index">
                <!-- <input class="checkbox-tools" type="radio" name="commission-giftcard" :id="`commission-giftcard-${item.id}`" :checked="giftcard_selected.id == item.id"
                    @click="selectItem(item)" />
                <label class="for-checkbox-tools text-lg" :for="`commission-giftcard-${item.id}`">
                    <span v-if="item.name != 'other'">{{item.start}} - {{item.end}}</span>
                    <span v-else>Other</span>
                </label> -->
                <vs-button type="border" class="text-lg percentage-btn" :class="{'active': giftcard_selected.id == item.id}" @click="selectItem(item)">
                    <span v-if="item.name != 'other'">{{item.start}} - {{item.end}}</span>
                    <span v-else-if="item.end == -1">Other</span>
                    <span v-else>{{item.start}} - {{item.end}}</span>
                </vs-button>
            </div>
        </div>

        <div class="flex items-center pt-base mt-3 pb-5">
            <h5 class="font-bold mr-8">Choose Cash - Check Proportion</h5>

            <ul class="centerx flex align-center justify-between space-x-8">
                <li class="flex items-center">
                    <vs-radio v-model="cashCheckType" name="cash-check-type" vs-value="percent">%</vs-radio>
                </li>
                <li class="flex items-center">
                    <vs-radio v-model="cashCheckType" name="cash-check-type" vs-value="usd">$</vs-radio>
                </li>
            </ul>
        </div>
        <div class="my-radio-list flex" v-if="cashCheckType == 'percent'">
            <div v-for="(item, index) in cashCheckPercentage" :key="index">
                <vs-button type="border" class="text-lg percentage-btn" :class="{'active': cashcheck_selected.id == item.id}" @click="selectItem(item)">
                    <span v-if="item.name != 'other'">{{item.start}} - {{item.end}}</span>
                    <span v-else-if="item.end == -1">Other</span>
                    <span v-else>{{item.start}} - {{item.end}}</span>
                </vs-button>
            </div>
        </div>
        <div v-else>
            <div class="flex items-center">
                <div class="fixed-cash-check-type-select">
                    <v-select @input="selectFixedCashCheckType($event)" :value="fixedCashCheckType" label="name" :options="fixedCashCheckTypeOptions" :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'" :searchable="false" />
                </div>
                <vs-input class="fixed-cash-check-type-input" v-model="fixedCashCheckValue" v-on:keypress="isNumber($event, fixedCashCheckValue)"></vs-input>
            </div>
        </div>

        <div>
            <h5 class="font-bold pt-base mt-3 pb-3">Deduction Per Day</h5>
            <vs-input v-model="deductionPerDay" v-on:keypress="isNumber($event, deductionPerDay)"></vs-input>
        </div>

        <div class="flex w-full">
            <div>
                <h5 class="font-bold pt-base mt-1 pb-3">Card Charge(%)</h5>
                <vs-input v-model="cardCharge" v-on:keypress="isNumber($event, cardCharge)"></vs-input>
            </div>
            <!-- <div class="cash-charge-margin">
                <h5 class="font-bold pt-base mt-3 pb-3">Cash Bonus(%)</h5>
                <vs-input v-model="cashCharge" v-on:keypress="isNumber($event, cashCharge)"></vs-input>
            </div> -->
        </div>

        <!-- <h5 class="font-bold pt-base mt-3 pb-3">Per hour salary($)</h5>
        <vs-input v-model="salaryPerHour" v-on:keypress="isNumber($event, salaryPerHour)"></vs-input> -->

        <p class='text-grey-custom mt-5 mb-base'>Do you want your employees to share credit card fees with you by withdrawing a percentage from the commission?</p>

        <div class="mb-base flex">
            <div class="flex align-start">
                <vs-switch class="credit-card-tip" v-model="creditCardTip" />
                <span @click="creditCardTip = !creditCardTip" class="pl-6 cursor-pointer font-bold color-black" :class="{'text-primary': creditCardTip}" style="font-size: 15.96px">Credit card tips added to check</span>
            </div>

            <div class="percentage-charge-margin">
                <h5 class="font-bold pb-3">Percentage charge(%)</h5>
                <vs-input v-model="percentageCharge" v-on:keypress="isNumber($event, percentageCharge)" :disabled="creditCardTip == false"></vs-input>
            </div>
        </div>

        <div class="flex justify-center mb-6">
            <vs-button type="border" color="danger" class="commission-btn cancel-btn" @click="outConfiguration">Back</vs-button>
            <vs-button class="ml-base commission-btn" @click="saveCommission">Finish</vs-button>
        </div>

        <vs-popup class="holamundo customize-percentage-popup" :title="customType == 'cashcheck' ? 'Customize Cash - Check Percentage' :'Customize Employee - Owner Percentage'" :active.sync="popupActive">
            <div class="text-center">
                <!-- <h3>Do you want to delete this staff?</h3> -->
                <div class="flex align-center mb-4">
                    <p class="w-1/2 text-left" v-if="customType == 'cashcheck'">Percent for Cash</p>
                    <p class="w-1/2 text-left" v-else>Percent for Employee</p>
                    <vs-input class="" v-model="customPercentage" v-on:keypress="isTwoDigitsAfterDecimalNumber($event, customPercentage)" />
                </div>

                <div class="flex align-center mb-4">
                     <p class="w-1/2 text-left" v-if="customType == 'cashcheck'">Percent for Check</p>
                    <p class="w-1/2 text-left" v-else>Percent for Owner</p>
                    <vs-input class="" :value="formatPercentToShow(100 - customPercentage)" disabled />
                </div>
                <div class="flex flex-wrap justify-center align-center p-6 mt-6">
                    <vs-button type="border" color="danger" class="mr-6 cancel-responsive" @click="popupActive = false">Cancel</vs-button>
                    <vs-button class="align-center delete-responsive" @click="saveOtherValue">Ok</vs-button>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>
import vSelect from 'vue-select'
export default {
    name: 'commission-content',
    components: { vSelect },
    props: {
      commissionList:{
        type : Object,
        required: true
      }
    },
    data() {
        let serviceCommission = [
          {id: 1, start: 70, end: 30, name: '70-30', type: 'service'},
          {id: 2, start: 60, end: 40, name: '60-40', type: 'service'},
          {id: 3, start: 50, end: 50, name: '50-50', type: 'service'},
          {id: 4, start: 40, end: 60, name: '40-60', type: 'service'},
          {id: 5, start: 0, end: 100, name: '0-100', type: 'service'},
          {id: 6, start: 0, end: -1, name: 'other', type: 'service'}
        ];
        let productCommission = [
          {id: 1, start: 70, end: 30, name: '70-30', type: 'product'},
          {id: 2, start: 60, end: 40, name: '60-40', type: 'product'},
          {id: 3, start: 50, end: 50, name: '50-50', type: 'product'},
          {id: 4, start: 40, end: 60, name: '40-60', type: 'product'},
          {id: 5, start: 0, end: 100, name: '0-100', type: 'product'},
          {id: 6, start: 0, end: -1, name: 'other', type: 'product'}
        ];
        let giftcardCommission = [
          {id: 1, start: 70, end: 30, name: '70-30', type: 'giftcard'},
          {id: 2, start: 60, end: 40, name: '60-40', type: 'giftcard'},
          {id: 3, start: 50, end: 50, name: '50-50', type: 'giftcard'},
          {id: 4, start: 40, end: 60, name: '40-60', type: 'giftcard'},
          {id: 5, start: 0, end: 100, name: '0-100', type: 'giftcard'},
          {id: 6, start: 0, end: -1, name: 'other', type: 'giftcard'}
        ];
        let cashCheckPercentage = [
          {id: 1, start: 70, end: 30, name: '70-30', type: 'cashcheck'},
          {id: 2, start: 60, end: 40, name: '60-40', type: 'cashcheck'},
          {id: 3, start: 50, end: 50, name: '50-50', type: 'cashcheck'},
          {id: 4, start: 40, end: 60, name: '40-60', type: 'cashcheck'},
          {id: 5, start: 0, end: -1, name: 'other', type: 'cashcheck'}
        ]

        let service_selected = serviceCommission[0];
        let product_selected = productCommission[0];
        let giftcard_selected = giftcardCommission[0];
        let cashcheck_selected = cashCheckPercentage[0];

        let cashCheckType = "percent";
        let deductionPerDay = 0;
        let fixedCashCheckType = "Cash";
        let fixedCashCheckValue = 0;

        if(this.commissionList && this.commissionList.commission){
          for(let i = 0; i < serviceCommission.length; i++){
            if(serviceCommission[i].start == this.formatPercent(this.commissionList.commission.service_rate)){
              service_selected = serviceCommission[i];
              break;
            }
            if(i == serviceCommission.length - 1){
            //   service_selected = {id: 6, start: 0, end: -1, name: 'other', type: 'service'}
              serviceCommission[serviceCommission.length - 1] = {id: 6, start: this.formatPercent(this.commissionList.commission.service_rate), end: this.formatPercent(1 - this.commissionList.commission.service_rate), name: 'other', type: 'service'}
              service_selected = {id: 6, start: this.formatPercent(this.commissionList.commission.service_rate), end: this.formatPercent(1 - this.commissionList.commission.service_rate), name: 'other', type: 'service'};
            }
          }

          for(let i = 0; i < productCommission.length; i++){
            if(productCommission[i].start == this.formatPercent(this.commissionList.commission.product_rate)){
              product_selected = productCommission[i];
              break;
            }
            if(i == productCommission.length - 1){
            //   product_selected = {id: 6, start: 0, end: -1, name: 'other', type: 'product'}
              productCommission[productCommission.length - 1] = {id: 6, start: this.formatPercent(this.commissionList.commission.product_rate), end: this.formatPercent(1 - this.commissionList.commission.product_rate), name: 'other', type: 'product'}
              product_selected = {id: 6, start: this.formatPercent(this.commissionList.commission.product_rate), end: this.formatPercent(1 - this.commissionList.commission.product_rate), name: 'other', type: 'product'}
            }
          }

          for(let i = 0; i < giftcardCommission.length; i++){
            if(giftcardCommission[i].start == this.formatPercent(this.commissionList.commission.gift_card_rate)){
              giftcard_selected = giftcardCommission[i];
              break;
            }
            if(i == giftcardCommission.length - 1){
            //   giftcard_selected = {id: 6, start: 0, end: -1, name: 'other', type: 'giftcard'}
              giftcardCommission[giftcardCommission.length - 1] = {id: 6, start: this.formatPercent(this.commissionList.commission.gift_card_rate), end: this.formatPercent(1 - this.commissionList.commission.gift_card_rate), name: 'other', type: 'giftcard'}
              giftcard_selected = {id: 6, start: this.formatPercent(this.commissionList.commission.gift_card_rate), end: this.formatPercent(1 - this.commissionList.commission.gift_card_rate), name: 'other', type: 'giftcard'}
            }
          }

           for(let i = 0; i < cashCheckPercentage.length; i++){
            if(cashCheckPercentage[i].start == this.formatPercent(this.commissionList.commission.cash_check_percentage)){
              cashcheck_selected = cashCheckPercentage[i];
              break;
            }
            if(i == cashCheckPercentage.length - 1){
            //   cashcheck_selected = {id: 5, start: 0, end: -1, name: 'other', type: 'cashcheck'}
              cashCheckPercentage[cashCheckPercentage.length - 1] = {id: 5, start: this.formatPercent(this.commissionList.commission.cash_check_percentage), end: this.formatPercent(1 - this.commissionList.commission.cash_check_percentage), name: 'other', type: 'cashcheck'}
              cashcheck_selected = {id: 5, start: this.formatPercent(this.commissionList.commission.cash_check_percentage), end: this.formatPercent(1 - this.commissionList.commission.cash_check_percentage), name: 'other', type: 'cashcheck'}
            }
          }
          cashCheckType = this.commissionList.commission.is_fixed_amount == 1 ? "usd" : "percent";
          fixedCashCheckType = this.commissionList.commission.check_fixed_amount ? "Check" : "Cash";
          fixedCashCheckValue = this.commissionList.commission.cash_fixed_amount || this.commissionList.commission.check_fixed_amount;
          deductionPerDay = this.commissionList.commission.deduction_per_day;
        }
        let creditCardTip = 0;
        if(this.commissionList.commission) {
          if(this.commissionList.commission.is_tip_to_check){
            creditCardTip = this.commissionList.commission.is_tip_to_check;
          }else {
            creditCardTip = 0;
          }
        }
        return {
            serviceCommission,
            productCommission,
            giftcardCommission,
            cashCheckPercentage,

            cardCharge: this.commissionList.commission ? this.formatFloatNum(this.commissionList.commission.card_charge) : 0,
            // cashCharge: this.commissionList.commission ? this.commissionList.commission.cash_charge*100 : 0,
            creditCardTip: creditCardTip == 1 ? true : false,
            percentageCharge: this.commissionList.commission ? this.formatFloatNum(this.commissionList.commission.tip_to_check_percentage) : 0,

            service_selected,
            product_selected,
            giftcard_selected,
            cashcheck_selected,

            active_item: null,

            popupActive: false,
            customPercentage: 0,
            customType: '',
            cashCheckType,
            fixedCashCheckType,
            fixedCashCheckValue,
            deductionPerDay,
            fixedCashCheckTypeOptions: [
                {
                    id: 1,
                    name: 'Cash'
                },
                {
                    id: 2,
                    name: 'Check'
                },
            ]
        }
    },
    // watch: {
    //     popupActive: {
    //         immediate: true,
    //         handler() {
    //             // this.customPercentage = 0;
    //         }
    //     }
    // },
    methods: {
        formatPercent(value) {
            // return Math.round((value/100) * 100 + Number.EPSILON ) / 100;
            return +(Math.round(value*100 + "e+2") + "e-2");
        },
        formatPercentToShow(value) {
            return +(Math.round(value + "e+2") + "e-2");
        },
        formatPercentToPost(value) {
            return +(Math.round(value/100 + "e+4") + "e-4");
        },
        formatFloatNumToPost(value) {
            return +(Math.round(value/100 + "e+7") + "e-7");
        },
        formatFloatNum(value) {
            return +(Math.round(value*100 + "e+5") + "e-5");
        },
        saveCommission(){
            if(this.cashCheckType != "percent" && (!this.fixedCashCheckValue || this.fixedCashCheckValue == "0")) {
                this.$vs.notify({
                    title:'Notification',
                    text:'Fixed amount must be greater than 0',
                    color:'danger',
                    position:'top-right'
                });
                return;
            }
            const obj = {
                type: 'commission',
                service_rate: this.formatPercentToPost(this.service_selected.start),
                product_rate: this.formatPercentToPost(this.product_selected.start),
                gift_card_rate: this.formatPercentToPost(this.giftcard_selected.start),
                cash_check_percentage: this.formatPercentToPost(this.cashcheck_selected.start),
                card_charge: this.formatFloatNumToPost(this.cardCharge),
                //   cash_charge: this.formatPercent(this.cashCharge),
                is_tip_to_check: this.creditCardTip ? 1 : 0,
                tip_to_check_percentage: this.creditCardTip ? this.formatFloatNumToPost(this.percentageCharge) : 0,
                deduction_per_day: this.deductionPerDay ? this.deductionPerDay : 0,
                cash_fixed_amount: this.fixedCashCheckType == "Cash" ? this.fixedCashCheckValue : 0,
                check_fixed_amount: this.fixedCashCheckType == "Check" ? this.fixedCashCheckValue : 0,
                is_fixed_amount: this.cashCheckType == "percent" ? 0 : 1
            }
            this.$emit("SaveCommission", obj)
        },
        selectItem(item) {
            if(item) {
                if(item.name != 'other') {
                    if(item.type == 'service') {
                        this.service_selected = item;
                    } else if (item.type == 'product') {
                        this.product_selected = item;
                    } else if (item.type == 'giftcard') {
                        this.giftcard_selected = item;
                    } else {
                        this.cashcheck_selected = item;
                    }
                } else {
                    this.active_item = item;
                    this.customPercentage = item.start;
                    this.customType = item.type;
                    this.popupActive = true;
                }
            }
        },
        isNumber: function(evt, num) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if (((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) || (charCode == 46 && num.toString().indexOf(".") != -1)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        isIntegerNumber: function(evt) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57))) {
                evt.preventDefault();
            } else {
                if(parseInt(this.customPercentage + '' + evt.key) <= 100) {
                    return true;
                } else {
                    evt.preventDefault();
                }
            }
        },
        isTwoDigitsAfterDecimalNumber: function(evt, num) {
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if (((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) || (charCode == 46 && num.toString().indexOf(".") != -1) ||
            ((charCode >= 48 && charCode <= 57) && num.toString().indexOf(".") != -1 && (num.toString().substring(num.toString().indexOf(".") + 1)).length == 2) || 
            ((charCode >= 48 && charCode <= 57) && parseFloat(num + '' + String.fromCharCode(charCode)) > 100)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        outConfiguration() {
            this.$emit('OutConfiguration');
        },
        saveOtherValue() {
            if(this.customPercentage == '') {
                this.customPercentage = 0;
            }
            if(this.customType == 'service') {
                this.service_selected = this.active_item;
                this.service_selected.start = this.formatPercentToShow(this.customPercentage);
                this.service_selected.end = this.formatPercentToShow(100 - this.customPercentage);
            } else if (this.customType == 'product') {
                this.product_selected = this.active_item;
                this.product_selected.start = this.formatPercentToShow(this.customPercentage);
                this.product_selected.end = this.formatPercentToShow(100 - this.customPercentage);
            } else if (this.customType == 'giftcard') {
                this.giftcard_selected = this.active_item;
                this.giftcard_selected.start = this.formatPercentToShow(this.customPercentage);
                this.giftcard_selected.end = this.formatPercentToShow(100 - this.customPercentage);
            } else {
                this.cashcheck_selected = this.active_item;
                this.cashcheck_selected.start = this.formatPercentToShow(this.customPercentage);
                this.cashcheck_selected.end = this.formatPercentToShow(100 - this.customPercentage);
            }
            this.popupActive = false;
        },
        selectFixedCashCheckType(e) {
            this.fixedCashCheckType = e.name;
        },
    },
}
</script>
